import React from 'react';
import Icon from '../../../components/AppIcon';

const ProgressIndicator = ({ currentStep, totalSteps, steps }) => {
  return (
    <div className="w-full mb-8">
      <div className="flex items-center justify-between mb-4">
        {steps.map((step, index) => (
          <div key={step.id} className="flex items-center">
            <div className={`flex items-center justify-center w-10 h-10 rounded-full border-2 transition-all duration-300 ${
              index < currentStep
                ? 'bg-[#7C3AED] border-[#7C3AED] text-white'
                : index === currentStep
                ? 'bg-black border-black text-white'
                : 'bg-black/5 border-black/10 text-black/40'
            }`}>
              {index < currentStep ? (
                <Icon name="Check" size={20} />
              ) : (
                <span className="text-sm font-medium">{index + 1}</span>
              )}
            </div>
            {index < steps.length - 1 && (
              <div className={`w-16 h-0.5 mx-2 transition-all duration-300 ${
                index < currentStep ? 'bg-[#7C3AED]' : 'bg-black/10'
              }`} />
            )}
          </div>
        ))}
      </div>

      <div className="text-center">
        <h3 className="text-lg font-semibold text-black mb-1">
          {steps[currentStep]?.title}
        </h3>
        <p className="text-sm text-black/50">
          Paso {currentStep + 1} de {totalSteps}
        </p>
      </div>
    </div>
  );
};

export default ProgressIndicator;